<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          @click:outside="closeModal(true)"
          persistent
        >
          <v-card class="custom-card pb-120" rounded="0">
            <v-toolbar flat color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">{{
                $t("farm.editUser")
              }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal(true)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form
              ref="userEdit"
              v-model="valid"
              lazy-validation
              autocomplete="off"
            >
              <v-card-text class="black--text">
                <div class="form">
                  <label for="name"
                    >{{ $t("name") }}<span style="color: red">*</span></label
                  >
                  <v-text-field
                    v-model="editedUser.name"
                    :placeholder="$t('name')"
                    outlined
                    dense
                    :error-messages="errors.name"
                    :rules="rules.name"
                  ></v-text-field>
                </div>
                <div class="form">
                  <label for="email"
                    >{{ $t("emailAddress")
                    }}<span style="color: red">*</span></label
                  >
                  <v-text-field
                    v-model="editedUser.email"
                    :placeholder="$t('emailAddress')"
                    outlined
                    dense
                    :error-messages="errors.email"
                    :rules="rules.email"
                  ></v-text-field>
                </div>
                <div class="form">
                  <label for="mobile"
                    >{{ $t("mobileNum")
                    }}</label
                  >
                  <v-row no-gutters>
                        <v-col cols="3" class="">
                          <v-autocomplete
                            style="background-color: #1F5D51;"
                            outlined
                            :items="countries"
                            item-value="MobileCode"
                            class="phone-drop rounded-r-0 outline-l-0"
                            :filter="filterCountry"
                            dense
                            ref="phoneSelect"
                            hide-details
                            @change="phoneSelected"
                            v-model="editedUser.countryCode"
                          >
                            <template v-slot:item="slotProps">
                                <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i> &nbsp;
                                {{` (+${slotProps.item.MobileCode }) ${slotProps.item.Name}` }}
                            </template>
                            <div class="truncate" slot="selection" slot-scope="data" style="color:white !important; font-size:12px; font-weight:bold;">
                                <span style="color:white !important;">
                                    <!-- <i :class="['em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>&nbsp; -->
                                    {{`( +${data.item.MobileCode } )` }}
                                </span>
                            </div>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="editedUser.mobile"
                            :placeholder="$t('mobileNum')"
                            outlined
                            dense
                            class="rounded-l-0"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                </div>
                <div class="form">
                  <label for="password"
                    >{{ $t("password")
                    }}<span style="color: red">*</span></label
                  >
                  <v-text-field
                    :type="passwordType"
                    v-model="password"
                    placeholder="*****"
                    outlined
                    dense
                    :error-messages="errors.password"
                    :append-icon="passwordIcon"
                    @click:append="changePasswordType"
                    autocomplete="off"
                  ></v-text-field>
                </div>
                <div class="form">
                  <label for="department"
                    >{{ $t("department")
                    }}<span style="color: red">*</span></label
                  >
                  <v-select
                    v-model="editedUser.department"
                    :items="departmentList"
                    item-text="name"
                    item-value="name"
                    outlined
                    dense
                    :error-messages="errors.department"
                    @change="getRoles"
                    :rules="rules.department"
                    :placeholder="$t('farm.selectDept')"
                  ></v-select>
                </div>
                <div class="form">
                  <label for="role"
                    >{{ $t("role") }}<span style="color: red">*</span></label
                  >
                  <v-select
                    v-model="editedUser.role"
                    :items="rolesList"
                    item-text="name"
                    item-value="name"
                    outlined
                    dense
                    :error-messages="errors.role"
                    :loading="roleLoading"
                    :rules="rules.role"
                    :placeholder="$t('farm.selectRole')"
                  ></v-select>
                </div>
                <v-card-actions class="mt-10 px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="closeModal(true)"
                    class="mr-2"
                    outlined
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    @click="updateUser"
                    right
                    height="44"
                    width="116"
                    color="primary"
                  >
                    {{ $t("submit") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <DataLostWarning
      :dialogI="dataLossWarning"
      v-if="dataLossWarning"
      @closeDialog="closeWarningMessage"
      @saveData="closeWarningMessage"
    ></DataLostWarning>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import PermissionsMixin from "@/mixins/PermissionsMixin";

import UserService from "@/_services/UserService";
import countries from "@/models/countries.js"

export default {
  created() {
    let codes = this.editedUser.mobile.split(" ")
    if(codes && codes.length == 2){
      this.countryCode = Number(codes[0])
      this.userMobile = codes[1]
    }


    const fetchData = async () => {
      this.startLoading();
      this.departmentList = await this.getDepartments();
      this.deptNameToId = {};
      this.departmentList.forEach(e => {
        this.deptNameToId[e.name] = e.departmentNumber;
      });
      if (this.editedUser.department)
        this.getRoles(this.deptNameToId[this.editedUser.department]);
      this.stopLoading();
    };
    fetchData();
  },
  computed: {
    dialog() {
      return this.dialogU;
    },
  },
  data() {
    return {
      // countryCode: '',
      // userMobile: '',
      countries,
      dataLossWarning: false,
      passwordType: "password",
      passwordIcon: "mdi-eye-off",
      deptNameToId: {},
      valid: true,
      departmentList: [],
      rolesList: [],
      roleLoading: false,
      fieldType: { text: "text" },
      error: false,
      errors: {
        name: "",
        email: "",
        // mobile: "",
        password: "",
        department: "",
        role: "",
      },
      editedUser: { ...this.user },
      password: "",
      rules: {
        name: [
          v => !!v || this.$t("nameIsRequired"),
          v => this.onlyAlpha(v) || this.$t("nameCanContainOnlyAlphabets"),
        ],
        email: [
          (v) => !!v || this.$t("emailRequired"),
          v =>
            v.length < 1 ||
            this.validateEmail(v) ||
            this.$t("invalidEmailFormat"),
        ],
        // mobile: [
        //   v => (v.length <= 12) || this.$t('Can\'t be more than 12 characters.'),
        //   // (v) => !!v || this.$t("mobNumReq"),
        //   // (v) => this.validMobileNumber(v) || this.$t("invalidMobFormat"),
        // ],
        department: [v => !!v || this.$t("departmentReq")],
        role: [v => !!v || this.$t("roleReq")],
      },
    };
  },
  methods: {
    filterCountry(item, queryText){
      return item.Name.toLocaleLowerCase().includes(queryText.toLocaleLowerCase())
          ||  item.MobileCode.toString().includes(queryText.toLocaleLowerCase())

    },
    phoneSelected() {
			this.$refs.phoneSelect.blur();
		},
    closeWarningMessage(res) {
      console.log("ress", res);
      this.dataLossWarning = false;
      if (!res) {
        this.$emit("closeUpdateUser");
      }
    },
    changePasswordType() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.passwordIcon = "mdi-eye";
      } else {
        this.passwordType = "password";
        this.passwordIcon = "mdi-eye-off";
      }
    },
    closeModal(warn) {
      this.dataLossWarning = warn;
      // this.$emit("closeUpdateUser");
    },

    updateUser() {
      // this.editedUser.mobile = this.countryCode + ' ' +this.userMobile
      /* eslint-disable */
      // this.emptyErrors();
      if (!this.editedUser.email) {
        this.errors.email = "Email is required.";
        // this.errors.mobile = "Email or Mobile Number is required.";
        this.error = true;
      }
      // if(!this.onlyAlpha(this.editedUser.name)){
      //     this.errors.name = 'Name can contain only alphbets';
      //     this.error = true;
      // }
      // if(!this.validateEmail(this.editedUser.email)){
      //     this.errors.email = 'Invalid email format.';
      //     this.error = true;
      // }
      // if(!this.validMobileNumber(this.editedUser.mobile)) {
      //     this.errors.mobile = 'Invalid mobile number format.';
      //     this.error = true;
      // }
      if (this.password.trim() != "") {
        this.editedUser.password = this.password;
      }
      if (this.error) return;

      if (!this.$refs.userEdit.validate()) return;
      this.startLoading();
      UserService.updateUser(this.editedUser)
        .then(data => {
          if (data.success) {
            this.$emit("userUpdated", { success: true, message: data.message });
          } else {
            this.$emit("userUpdated", {
              success: false,
              message: data.message,
            });
          }
          this.$emit("closeUpdateUser");
          this.stopLoading();
        })
        .catch(err => {
          if (err?.response?.data?.message?.errors?.length > 0) {
            err.response.data.message.errors.forEach(e => {
              this.errors[e.param] = e.msg;
            });
          }
          this.$notify({
            title: this.$t("unableToUpdate"),
            type: "error",
          });
          this.stopLoading();
        });
    },

    emptyErrors() {
      this.error = false;
      this.errors.name = "";
      this.errors.email = "";
      // this.errors.mobile = "";
      this.errors.password = "";
      this.errors.department = "";
      this.errors.role = "";
    },
    async getRoles() {
      this.rolesList = [];
      this.roleLoading = true;
      this.rolesList = await this.getRolesList(
        this.deptNameToId[this.editedUser.department]
      );
      this.roleLoading = false;
    },
  },
  props: {
    dialogU: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  mixins: [loadingMixin, generalMixin, PermissionsMixin],
};
</script>

<style lang="scss">
.v-dialog::-webkit-scrollbar {
  width: 0px;
}
.v-dialog::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.v-dialog::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.custom-card {
  background: #ffffff !important;
  box-shadow: 0px 30px 30px rgb(106 119 132 / 41%) !important;
  border-radius: 23px !important;
}
.custom-card .v-card__text {
  width: 100%;
  padding: 37px 60px !important;
}
.card-heading-1 {
  margin-bottom: 28px;
}
.custom-card .v-card__text .card-heading-1 h2 {
  font-size: 30px;
  font-weight: 700;
}
// .custom-card .form {
// 	margin-bottom: 22px;
// }
.form label {
  display: inline-block;
  max-width: 100%;
  // margin-bottom: 5px;
  font-size: 15px;
  font-family: Poppins-Medium;
}
.form .form-control {
  display: block;
  width: 100%;
  height: 36px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  /* color: #555; */
  background-color: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
}
.form .form-control::placeholder {
  font-size: 13px;
  font-family: pop_regular;
  color: #97a8b8;
}
.form .form-control:focus-visible {
  outline: none;
}
// .form-control-2 {
// 	display: block;
// 	width: 100%;
// 	height: 36px;
// 	padding: 1px 20px;
// 	line-height: 1.5;
// 	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
// 	background: #fff;
// 	border: 1px solid #C7D5E1;
// 	border-radius: 3px;
// 	background-position: calc(100% - 1.20rem) center !important;
// 	-moz-appearance: none !important;
// 	-webkit-appearance: none !important;
// 	appearance: none !important;
// 	background-image: url(/img/drop2.png);
// 	background-repeat: no-repeat;
// 	font-size: 14px;
// 	/* color:#C7D5E1; */
// 	font-family: pop_regular;
// }
.btn-custom-11 .btn-11 {
  width: 135px;
  background: #fff !important;
  color: $outline-color !important;
  border: 1px solid #97a8b8 !important;
}
.btn-custom-11 .btn-22 {
  width: 135px;
  background: $primary-color !important;
  color: #fff !important;
  margin-left: 10px;
}
.btn-custom-11 {
  margin-top: 38px;
}
</style>
